import { useForm } from '@refinedev/antd';
import { Edit } from '@refinedev/antd';
import { Form, Input, InputNumber, Switch } from 'antd';

export const FaqEdit = () => {
  const { formProps, saveButtonProps } = useForm({
    resource: 'admin/faqs',
    redirect: 'list',
  });

  return (
    <Edit saveButtonProps={saveButtonProps} title="FAQ tahrirlash">
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Savol (O'zbekcha)"
          name="questionUz"
          rules={[{ required: true, message: 'Savolni kiriting' }]}
        >
          <Input.TextArea rows={2} placeholder="Savol..." />
        </Form.Item>

        <Form.Item
          label="Javob (O'zbekcha)"
          name="answerUz"
          rules={[{ required: true, message: 'Javobni kiriting' }]}
        >
          <Input.TextArea rows={4} placeholder="Javob..." />
        </Form.Item>

        <Form.Item
          label="Savol (Ruscha)"
          name="questionRu"
          rules={[{ required: true, message: 'Savolni kiriting' }]}
        >
          <Input.TextArea rows={2} placeholder="Вопрос..." />
        </Form.Item>

        <Form.Item
          label="Javob (Ruscha)"
          name="answerRu"
          rules={[{ required: true, message: 'Javobni kiriting' }]}
        >
          <Input.TextArea rows={4} placeholder="Ответ..." />
        </Form.Item>

        <Form.Item
          label="Savol (Inglizcha)"
          name="questionEn"
          rules={[{ required: true, message: 'Savolni kiriting' }]}
        >
          <Input.TextArea rows={2} placeholder="Question..." />
        </Form.Item>

        <Form.Item
          label="Javob (Inglizcha)"
          name="answerEn"
          rules={[{ required: true, message: 'Javobni kiriting' }]}
        >
          <Input.TextArea rows={4} placeholder="Answer..." />
        </Form.Item>

        <Form.Item label="Kategoriya" name="category">
          <Input placeholder="Kategoriya nomi" />
        </Form.Item>

        <Form.Item label="Tartib raqami" name="sortOrder">
          <InputNumber min={0} style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item label="Faol" name="isActive" valuePropName="checked">
          <Switch />
        </Form.Item>
      </Form>
    </Edit>
  );
};
